import * as React from "react";

import {cs}       from "@Common/react/chain-services";

import {BaseCardModal} from "./base-card-modal/base-card-modal";
import {Step1}         from "./step-1/step-1";
import {Step2}         from "./step-2/step-2";

export const AddCardModal = ({apisAddUpdate, next}) => cs(
    ({}) => BaseCardModal({
        renderSteps: ({next, params}) => cs(
            ["step1", (_, next) => Step1({next, recaptchaToken: params.recaptchaToken})],
            ["step2", (_, next) => Step2({
                data: {
                    country: "US",
                },
                next,
            })],
            ({step1, step2}) => next([step1, step2]),
        ),
        title: "Add Card",
        action: {
            label: "Add",
            submittingLabel: "Adding...",
        },
        apisAddUpdate,
        next,
    }),
);
